import { render, staticRenderFns } from "./cssButton.vue?vue&type=template&id=ec55fd14&scoped=true"
import script from "./cssButton.vue?vue&type=script&lang=js"
export * from "./cssButton.vue?vue&type=script&lang=js"
import style0 from "./cssButton.vue?vue&type=style&index=0&id=ec55fd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec55fd14",
  null
  
)

export default component.exports